import { prop } from "fw";

export class ScrollView {
  @prop(1000) maxHeight!: number;
  @prop(1000) maxWidth!: number;
}
